// Label for a fare breakup row; pickup fee gets the pickup distance appended, e.g. "Pickup fee (2 km)".
export const getFareBreakupLabel = (key, label, priceBreakup) => {
  const pickupDistance = priceBreakup?.pickup_distance;

  if (key === "pickup_fee" && pickupDistance !== undefined && pickupDistance !== null && pickupDistance !== "") {
    return `${label} (${pickupDistance} km)`;
  }

  return label;
};
